export default __webpack_public_path__ + "static/media/yellowTheme-girl.a4dd9ade.svg";